import "../../pages/recall-details.css";
import { convertInMonthNameFormat } from "../../utils/helper";
import PropTypes from "prop-types";
import { RenderRichText } from "./render-rich-text";

export const PressComponent = ({ item }) => {
  const hasRichData = Boolean(item?.rich_text_enabled);

  let recallDate = item.recall_date;
  if (
    item.recall_date &&
    typeof item.recall_date === "string" &&
    item.recall_date.includes("/")
  ) {
    const [day, month, year] = item.recall_date.split("/");
    recallDate = `${year}-${month}-${day}`;
  }
  return (
    <>
      <div
        style={{
          backgroundColor: "#D5E4F0",
          borderRadius: "10px",
          display: "flex",
          flexDirection: "column",
          padding: "10px",
          marginTop: "10px"
        }}>
        {item?.recall_title && (
          <h3 className="recall-summary">{item.recall_title}</h3>
        )}
        <div style={{ display: "flex", gap: "12px", flexWrap: "nowrap" }}>
          {item?.id && (
            <div style={{ flex: "1 1 150px" }}>
              <div className="recall-details-card-item">
                <span>{item.id}</span>
                <span> Recall ID </span>
              </div>
            </div>
          )}
          {item?.created_on && (
            <div style={{ flex: "1 1 150px" }}>
              <div className="recall-details-card-item">
                <span>{convertInMonthNameFormat(recallDate)}</span>
                <span>Recall Date</span>
              </div>
            </div>
          )}
          {item?.recalled_by && (
            <div style={{ flex: "1 1 150px" }}>
              <div className="recall-details-card-item">
                <span>{item.recalled_by}</span>
                <span>Recalled By</span>
              </div>
            </div>
          )}
          {item?.no_of_units && (
            <div style={{ flex: "1 1 150px" }}>
              <div className="recall-details-card-item">
                <span>{item.no_of_units}</span>
                <span>No of Units</span>
              </div>
            </div>
          )}
        </div>
      </div>
      {item?.impact && (
        <div className="recall-details-body-item">
          <h2>Impact</h2>
          <p>{item.impact}</p>
        </div>
      )}
      {item?.recall_due_to_component && (
        <div className="recall-details-body-item">
          <h2>Recall due to Component</h2>
          <p>{item.recall_due_to_component}</p>
        </div>
      )}
      {item?.recall_product_details && (
        <div className="recall-details-body-item">
          <h2>Recall Product Details</h2>
          <p>{item.recall_product_details}</p>
        </div>
      )}
      {item?.items_recalled && (
        <div className="recall-details-body-item">
          <h2>Items Recalled</h2>
          {hasRichData ? (
            <RenderRichText text={item.items_recalled} />
          ) : (
            <p>{item.items_recalled}</p>
          )}
        </div>
      )}
      {item?.affected_locations && (
        <div className="recall-details-body-item">
          <h2>Affected Locations</h2>
          <p>{item.affected_locations}</p>
        </div>
      )}
      {item?.reason_for_recall && (
        <div className="recall-details-body-item">
          <h2>Reason For Recall</h2>
          <p>{item.reason_for_recall}</p>
        </div>
      )}
      {item?.remedy && (
        <div className="recall-details-body-item">
          <h2>Remedy</h2>
          {hasRichData ? (
            <RenderRichText text={item.remedy} />
          ) : (
            <p>{item.remedy}</p>
          )}
        </div>
      )}
      {item?.consequences && (
        <div className="recall-details-body-item">
          <h2>Consequences</h2>
          {hasRichData ? (
            <RenderRichText text={item.consequences} />
          ) : (
            <p>{item.consequences}</p>
          )}
        </div>
      )}
      {item?.source && (
        <div className="recall-details-body-item">
          <h2>Source</h2>
          {hasRichData ? (
            <RenderRichText text={item.source} />
          ) : (
            <p>{item.source}</p>
          )}
        </div>
      )}
      {item?.summary && (
        <div className="recall-details-body-item">
          <h2>Summary</h2>
          {hasRichData ? (
            <RenderRichText text={item.summary} />
          ) : (
            <p>{item.summary}</p>
          )}
        </div>
      )}
      {item?.recall_link && (
        <div className="recall-details-body-item">
          <h2>Link</h2>
          <p>
            <a href={item.recall_link} target="_blank" rel="noreferrer">
              {item.recall_link}
            </a>
          </p>
        </div>
      )}
    </>
  );
};
PressComponent.propTypes = {
  item: PropTypes.object.isRequired
};
